import React from 'react'
import Layout from './Layout';
import { useDispatch, useSelector } from 'react-redux';
import { nextStep, setFormData } from '../../redux/slice/findJobSlice';
import { ENGLISH_LEVEL } from '../../helpers/constants';
import Image from '../../components/general/Image';
import Button from '../../components/general/Button';
import { ArrowUpRight } from '../../components/common/Icons';

const StepSevenForm = () => {
    const dispatch = useDispatch();
    const { english_level } = useSelector(state => state.findJob.stepSevenData);

    const handleSelect = (value) => {
        dispatch(setFormData({ formData: { english_level: value } }));
    }

    return (
        <div className='min-h-[60vh] !py-[50px] !pb-[100px] lg:flex lg:justify-between lg:gap-[20px]'>
            <div className='lg:w-[40%]'>
                <div>
                    <p className='text-primary-color'> 7/8 </p>
                    <h1 className="text-[1.6rem] font-semibold">
                        <span className='lg:block'> What kind of project are </span>
                        {/* <Image src={DoubleStar} alt="double-star" className="hidden lg:inline-block" /> */}
                        <span className='lg:block'>you looking for?</span>
                    </h1>
                </div>

                <div className='hidden lg:block mt-[20px] text-[#2A2A2A]'>
                    <div className='mt-[20px] text-[#2A2A2A]'>
                        <p> 8/8 </p>
                        <h1 className="text-[1.6rem] font-semibold text-[#2A2A2A]">
                            <span> What is your hourly rate </span>
                            <span className='lg:block'>range?</span>
                        </h1>
                    </div>
                </div>
            </div>

            <div className='lg:w-[65%]'>
                <div className='hidden lg:flex gap-[20px] lg:justify-center text-[13px] mb-[50px]'>
                    <p className='text-primary-color'> 1. Project Preferences </p>
                    <p> 2. Specialization in stack </p>
                    <p> 3. Additional info </p>
                    <p> 4. Registration </p>
                </div>

                <div className='text-[15px] mb-[30px]'>
                    <div className='flex items-start justify-center gap-[10px] text-[#797979]'>
                        <svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" strokeWidth={1.5} stroke="currentColor" className="size-6 hidden lg:block">
                            <path strokeLinecap="round" strokeLinejoin="round" d="M12 9v3.75m9-.75a9 9 0 1 1-18 0 9 9 0 0 1 18 0Zm-9 3.75h.008v.008H12v-.008Z" />
                        </svg>

                        <div className='text-left lg:text-center'>
                            Please, be reasonable while estimating your skills - we'll assess your actual
                            English level on the first screening
                        </div>
                    </div>
                    <div className='text-left lg:text-center text-[#797979]'>
                        steps English level on the first screening steps
                    </div>
                </div>
                <div className='flex flex-col md:grid md:grid-cols-2 gap-4 mt-[20px]'>
                    {
                        Object.keys(ENGLISH_LEVEL).map((key) => {
                            return (
                                <div key={key} className={`bg-[#292929] rounded-[6px] flex items-center gap-4 justify-start p-[10px] lg:p-[20px] cursor-pointer ${english_level === key ? 'border border-primary-color bg-black' : ''}`} onClick={() => handleSelect(key)}>
                                    <Image src={ENGLISH_LEVEL[key].image} alt={ENGLISH_LEVEL[key]} />

                                    <div>
                                        <h3 className='text-[18px] lg:text-[1rem] font-bold'>{ENGLISH_LEVEL[key].primaryText}</h3>
                                        <p className='text-[14px] lg:text-[0.7rem] font-light'>{ENGLISH_LEVEL[key].secondaryText}</p>
                                    </div>
                                </div>
                            )
                        })
                    }

                </div>
                <Button onClick={() => dispatch(nextStep())} className='w-full bg-primary-color text-black h-[40px] lg:h-[50px] text-[1rem] lg:text-[1rem] lg:mx-auto rounded mt-[20px] md:w-[200px] lg:mt-[50px]' disabled={!Boolean(english_level)}>
                  <div className="flex items-center justify-center gap-2">
                    <span>Ok, next</span>
                    <ArrowUpRight className="w-4 h-4" />
                  </div>
                </Button>
            </div>
        </div>
    )
}

export default StepSevenForm;